// Section 9 and 7: Cistern. 8 build points, 4 wood and 6 stone; +40 water capacity; water in
// it does not evaporate (0% instead of 20%). Constants: config.buildings.cistern.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import {
  buildingEffectHook,
  capacityHook,
  combineModifiers,
  effective,
  noDeltas,
} from '../../core/content-helpers';
import { defineBuilding } from '../../core/registry';

export function cistern(config: Config) {
  const c = config.buildings.cistern;

  return defineBuilding({
    id: 'cistern',
    label: 'Cistern',
    section: 'S9',
    buildPoints: c.buildPoints,
    materials: { wood: c.wood, stone: c.stone },
    material: 'stone',
    beds: 0,
    plots: 0,
    capacity: { water: c.waterCapacity },
    limit: { kind: 'none' },
    modifierTargets: ['capacity', 'spoilage', 'buildingEffect'],
    modifiers: combineModifiers(
      buildingEffectHook('cistern'),
      capacityHook('cistern', { water: c.waterCapacity }),
      (ctx, target) => {
        if (target.kind !== 'spoilage' || target.resource !== 'water') return [];
        const amount = ctx.state.stocks.water.amount;
        const held = Math.min(amount, c.waterCapacity * effective(ctx, 'cistern'));
        if (held <= 0) return [];
        const rate =
          (held * c.waterSpoilage + (amount - held) * config.resources.spoilage.water) / amount;
        return [mod.set('building:cistern', rate, 'stored in cistern')];
      },
    ),
    onComplete: noDeltas,
    onDamaged: noDeltas,
  });
}
